module.exports = __webpack_public_path__ + "img/double_bubble_layout_1.92d50ea5.jpg";